import React from 'react'
import _ from 'lodash'
import {HashTag, DeepLink} from '../services/hashtag'

export default {
    pushDeepLink: function(type, data, navigate = true) {
  	let deepLink = ''
  	switch (type) {
  		case 'LEG':  			
	      if (data.leg) {
	        deepLink = DeepLink.new(
                        DeepLink.segment.activeItinerary(), 
                        DeepLink.segment.leg(data.leg)
                    )
	      } else {
	        deepLink = DeepLink.new(DeepLink.segment.activeItinerary())
	      }	  
	      break 
            case 'UISTATUS':
                if (data.leg) {
                    if (data.subsection == 'DETAILS' && data.activeObj) {
                        let objSegment = ''
                        if (data.section == 'ACCOMMODATIONS') {
                            objSegment = DeepLink.segment.accommodation(data.activeObj)
                        } else if (data.section == 'ACTIVITIES') {
                            objSegment = DeepLink.segment.activity(data.activeObj)
                        }

                        deepLink = DeepLink.new(
                            DeepLink.segment.activeItinerary(), 
                            DeepLink.segment.leg(data.leg),
                            DeepLink.segment.uistatus(data.section, data.subsection, data.subdetail),
                            objSegment
                        )
                    } else {
                        deepLink = DeepLink.new(
                            DeepLink.segment.activeItinerary(), 
                            DeepLink.segment.leg(data.leg),
                            DeepLink.segment.uistatus(data.section, data.subsection, data.subdetail)
                        )  
                    }
                } else {
                    deepLink = DeepLink.new(DeepLink.segment.activeItinerary())
                }
                break     			
  		case 'DESTINATION':
  			break
  		case 'ACCOMMODATIONS':
  			deepLink = DeepLink.new(
                    DeepLink.segment.activeItinerary(), 
                    DeepLink.segment.leg(data.leg),
                    DeepLink.segment.uistatus(data.section, data.subSection)
                )
  			break
  		case 'ACTIVITIES':
  			break
  		case 'TRAVEL':
  			break
  		default:
  	}

        if (!navigate) {
            return '#' + deepLink.path()
        } else {  	
            if (window.location.hash !== '#' + deepLink.path()) {      
                if (deepLink != '') window.history.pushState({}, '', '#' + deepLink.path())          
            }
  	}
    }
}